export function defaultServerMessage() {
	return {
		message: '',
		severity: ''
	};
}
